import { render, staticRenderFns } from "./Content.vue?vue&type=template&id=124f4190&scoped=true"
import script from "./Content.vue?vue&type=script&lang=js"
export * from "./Content.vue?vue&type=script&lang=js"
import style0 from "./Content.vue?vue&type=style&index=0&id=124f4190&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124f4190",
  null
  
)

export default component.exports